// extracted by mini-css-extract-plugin
module.exports = {"send-button":"styles-module__send-button___1mCzs"};